import { useEffect } from 'react';
import { usePageTitle } from '@/hooks/use-page-title';
import { useHeaderAction } from '@/lib/header-action-context';
import { Card } from '@/components/ui/card';
import { Settings } from 'lucide-react';

export default function SettingsPage() {
    usePageTitle('Settings');
    const { setHeaderTitle } = useHeaderAction();

    useEffect(() => {
        setHeaderTitle({
            icon: (
                <div
                    className="flex h-7 w-7 items-center justify-center rounded-md text-slate-600"
                    style={{ backgroundColor: 'color-mix(in srgb, #78716c 30%, white)' }}
                >
                    <Settings size={16} />
                </div>
            ),
            title: 'Settings',
            subtitle: 'Platform configuration and preferences.',
            intense: true,
        });
        return () => setHeaderTitle(null);
    }, [setHeaderTitle]);

    return (
        <div className="px-6 py-6 space-y-6">
            <Card className="p-12 text-center border border-dashed border-slate-300 bg-slate-50">
                <div className="flex flex-col items-center gap-3">
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-slate-100">
                        <Settings size={24} className="text-slate-400" />
                    </div>
                    <p className="text-sm text-slate-500">Settings interface coming soon.</p>
                </div>
            </Card>
        </div>
    );
}
